// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroTwoToneSvg from "@ant-design/icons-svg/es/asn/EuroTwoTone";
import AntdIcon from '../components/AntdIcon';

var EuroTwoTone = function EuroTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroTwoToneSvg
  }));
};

EuroTwoTone.displayName = 'EuroTwoTone';
export default React.forwardRef(EuroTwoTone);